import React, { useState, useEffect } from "react";
import { RiMapPinFill } from "react-icons/ri";
import { APIProvider, Map } from "@vis.gl/react-google-maps";

import "./styles.css";

const ListingMiniMap = ({ params, locationDetails }) => {
  const location = locationDetails;

  const zoomlevel = calculateZoomLevel(location);

  const [mapInstance, setMapInstance] = useState(null);

  useEffect(() => {
    if (!mapInstance || !location) return;

    mapInstance.panTo({ lat: location.latitude, lng: location.longitude });
    mapInstance.setZoom(zoomlevel);
  }, [mapInstance, location, zoomlevel]);

  if (typeof location.latitude !== "number" || typeof location.longitude !== "number" || isNaN(location.latitude) || isNaN(location.longitude)) {
    return <div>Loading map...</div>;
  }

  return (
    <APIProvider apiKey={process.env.REACT_APP_GOOGLE_API_KEY}>
      <Map
        scrollwheel={true}
        style={{
          width: "100%",
          height: "150px",
        }}
        defaultCenter={{ lat: location?.latitude, lng: location?.longitude }}
        center={{ lat: location?.latitude, lng: location?.longitude }}
        mapId={process.env.REACT_APP_GOOGLE_MAP_ID}
        fullscreenControl={false}
        defaultZoom={zoomlevel}
        zoom={zoomlevel}
        mapTypeControl={false}
        zoomControlOptions={false}
        options={{
          draggableCursor: "pointer",
          maxZoom: 18,
          minZoom: 6,
          clickableIcons: false,
          visibility: "off",
          scrollwheel: false,
        }}
        zoomControl={false}
        onLoad={(map) => setMapInstance(map)}
      ></Map>
      <button className="map-inside-button">
        <RiMapPinFill />
        Show on map
      </button>
    </APIProvider>
  );
};

export default ListingMiniMap;

function calculateZoomLevel(location) {
  if (location?.city) {
    return 13;
  } else if (location?.district) {
    return 11.5;
  } else if (location?.province) {
    return 10.8;
  } else if (location?.country) {
    return 5;
  } else {
    return 10;
  }
}
